import { render, staticRenderFns } from "./cog.vue?vue&type=template&id=5570f414&"
import script from "./cog.vue?vue&type=script&lang=js&"
export * from "./cog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports